export const TOP_BAR_HEIGHT = 55;

export const PORTAL_ABOVE_MODAL_ID = 'portal-above-modal';
export const PORTAL_ABOVE_MOBILE_MENU_ID = 'portal-above-mobile-menu';

export enum Experiments {
    ARStreaming = 'ar-streaming',
    ARStreamingExtension = 'ar-streaming-extension',
    AgenticChat = 'agentic-chat-rollout',
}

const experiments: Record<Experiments, boolean> = {
    [Experiments.ARStreaming]: false,
    [Experiments.ARStreamingExtension]: false,
    [Experiments.AgenticChat]: false,
};

export const getExperiment = (experiment: Experiments) => {
    return experiments[experiment];
};

export const setExperiment = (experiment: Experiments, value: boolean) => {
    experiments[experiment] = value;
};

export const getAllExperiments = () => {
    return experiments;
};
